<template>
  <a-layout-content>
    <s-banner></s-banner>
    <div class="content">
      <a-breadcrumb style="margin: 16px 0">
        <a-breadcrumb-item>我收藏的关键人</a-breadcrumb-item>
      </a-breadcrumb>

      <a-row :gutter="48">
        <a-col>
          <router-link :to="{name:'keyperson'}">
            &lt;&lt;返回
            </router-link>
        </a-col>
        <a-col :md="{span:16,offset:4}" :sm="24">
          <a-card>
            <a-form layout="horizontal">
              <div class="persion-avatar"></div>
              <a-form-item label="姓名">
                <label v-html="keyPersion.name"></label>
              </a-form-item>
              <a-form-item label="公司">
                <label v-html="keyPersion.company"></label>
              </a-form-item>
              <a-form-item label="公司网址">
                <label v-html="keyPersion.website"></label>
              </a-form-item>
              <a-form-item label="部门">
                <label v-html="keyPersion.dept"></label>
              </a-form-item>
              <a-form-item label="职务">
                <label v-html="keyPersion.job"></label>
              </a-form-item>
              <a-form-item label="邮箱">
                <label v-html="keyPersion.email"></label>
              </a-form-item>
              <a-form-item label="Facebook/LinkedIn">
                <label v-html="keyPersion.facebook"></label>
              </a-form-item>
              <a-form-item label="个人简介">
                <label v-html="keyPersion.profile"></label>
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>

    </div>
  </a-layout-content>
</template>

<script>
import Banner from "./banner";
export default {
  data() {
    return {
      keyPersion: {}
    };
  },
  components: { "s-banner": Banner },
  methods: {},
  created() {
    this.$http
      .get(`/keypersiondetail?id=${this.$route.params.id}`)
      .then(res => {})
      .catch(err => {
        this.keyPersion = {
          name: "王先生",
          company: "厦门市盈拓商务有限公司",
          email: "23923330@qq.com",
          profile: "2013年2月-2018年9月就职于厦门市盈拓商务有限公司......",
          dept: "采购部",
          job: "采购经理",
          website: "www.zouchuqu.com"
        };
      });
  }
};
</script>
<style lang="scss">
.ant-form-item {
  height: 30px;
  margin-bottom: 5px;
}
.ant-form-item-control-wrapper {
  display: inline-block;
}
</style>

<style lang="scss" scoped>
.persion-avatar {
  float: right;
  background: red;
  height: 150px;
  width: 300px;
}
</style>
